import React from 'react'
import { spacing } from '@vacationtracker/shared/constants/ThemeSetting'

export type StackDirection = 'vertical' | 'horizontal'

export interface StackProps {
  direction?: StackDirection
  /** Gap between children, from the spacing scale. Default: 'base' (16px). */
  gap?: keyof typeof spacing
  align?: React.CSSProperties['alignItems']
  justify?: React.CSSProperties['justifyContent']
  wrap?: boolean
  children: React.ReactNode
  style?: React.CSSProperties
  /** Escape hatch for callers with existing CSS keyed off a class, same pattern as Text/TextField. */
  className?: string
}

/**
 * Vacation Tracker's flex layout wrapper. Replaces ad hoc `display: flex` inline
 * styles scattered across pages with one props-driven component built on the
 * spacing scale.
 */
export function Stack({ direction = 'vertical', gap = 'base', align, justify, wrap = false, children, style, className }: StackProps) {
  return (
    <div
      className={className}
      style={{
        display: 'flex',
        flexDirection: direction === 'vertical' ? 'column' : 'row',
        gap: spacing[gap],
        alignItems: align,
        justifyContent: justify,
        flexWrap: wrap ? 'wrap' : undefined,
        ...style,
      }}
    >
      {children}
    </div>
  )
}

export default Stack
